module.exports = __webpack_public_path__ + "static/media/ro.488ee906.svg";